import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateClientInductionReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/SpecificClientInductionReport`,
      params: {
        ...apiData,
        client_org_ids: JSON.stringify(apiData.client_org_ids),
        provider_org_ids: JSON.stringify(
          apiData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
        com_ind_ids: JSON.stringify(
          apiData.com_ind_ids?.map((item) => item?.induction_id)
        ),
        site_ind_ids: JSON.stringify(
          apiData.site_ind_ids?.map((item) => item?.induction_id)
        ),
        worker_ids: JSON.stringify(
          apiData.worker_ids?.map((item) =>
            typeof item === "object" ? item?.worker_id ?? item?.id : item
          )
        ),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GenerateClientInvoiceReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/SpecificClientInvoiceReport`,
      params: {
        ...apiData,
        client_org_ids: JSON.stringify([storedData?.organisation_id]),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GenerateClientProviderDocsReport =
  (apiData) => async (dispatch) => {
    try {
      const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
          organisationid: storedData?.organisation_id,
        },
        url: `${actionType.environment_url}/api/client/SpecificClientProviderDocsReport`,
        params: {
          ...apiData,
          // status: apiData.status.replace(/\s+/g, "_"),
          client_org_ids: JSON.stringify([storedData?.organisation_id]),
          provider_org_ids: JSON.stringify(
            apiData.provider_org_ids?.map((item) => item?.provider_org_id)
          ),
          provider_type_ids: JSON.stringify(apiData.provider_type_ids),
          document_ids: JSON.stringify(apiData.document_ids),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };

/*** CreateComplianceChecklistReport Action ***/
export const CreateComplianceChecklistReportStart = () => {
  return {
    error: null,
    loader: true,
    isAuthenticated: true,
    type: actionType.CreateComplianceChecklistReport_START,
  };
};
export const CreateComplianceChecklistReportSuccess = (response) => {
  return {
    error: false,
    loader: false,
    isAuthenticated: response.status === 401 ? false : true,
    type: actionType.CreateComplianceChecklistReport_SUCCESS,
  };
};
export const CreateComplianceChecklistReportFail = (error) => {
  return {
    error: error,
    loader: false,
    isAuthenticated: error.status === 401 ? false : true,
    type: actionType.CreateComplianceChecklistReport_FAIL,
  };
};

export const CreateComplianceChecklistReportSection = ({
  filterpage,
  filterlimit,
  filtersort,
  filterorder,
  client_org_ids,
  date_range,
  cheklistIds,
  recipientType,
  publishDate,
  renewalDate,
}) => {
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  return (dispatch) => {
    dispatch(CreateComplianceChecklistReportStart());
    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/client/SpecificClientChecklistReport`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
      },
      params: {
        limit: filterlimit,
        page: filterpage,
        sort: filtersort,
        order: filterorder,
        client_org_ids: client_org_ids ? JSON.stringify(client_org_ids) : [],
        date_range: date_range,
        checklist_ids: cheklistIds ? JSON.stringify(cheklistIds) : [],
        recipient_type: recipientType,
        joined_date_range: publishDate,
        renewal_date_range: renewalDate,
      },
    };

    return axios(config)
      .then(function (response) {
        dispatch(CreateComplianceChecklistReportSuccess(response.data));
        return response.data;
      })
      .catch(function (error) {
        dispatch(
          CreateComplianceChecklistReportFail(
            "Something went wrong, Please try again."
          )
        );
        return error;
      });
  };
};

/*** GenerateClientSitesReport Action ***/
export const GenerateClientSitesReportStart = () => {
  return {
    error: null,
    loader: true,
    isAuthenticated: true,
    type: actionType.GenerateClientSitesReport_START,
  };
};
export const GenerateClientSitesReportSuccess = (response) => {
  return {
    error: false,
    loader: false,
    isAuthenticated: response.status === 401 ? false : true,
    type: actionType.GenerateClientSitesReport_SUCCESS,
  };
};
export const GenerateClientSitesReportFail = (error) => {
  return {
    error: error,
    loader: false,
    isAuthenticated: error.status === 401 ? false : true,
    type: actionType.GenerateClientSitesReport_FAIL,
  };
};
export const GenerateClientSitesReportSection = ({
  filterpage,
  filterlimit,
  filtersort,
  filterorder,
  filterStatus,
  client_org_ids,
  date_range,
  siteIds,
  stateIds,
}) => {
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  return (dispatch) => {
    dispatch(GenerateClientSitesReportStart());

    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/client/SpecificClientSitesReport`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
      },
      params: {
        limit: filterlimit,
        page: filterpage,
        sort: filtersort,
        order: filterorder,
        is_active: filterStatus,
        client_org_ids: JSON.stringify(client_org_ids),
        created_date_range: date_range,
        site_ids: JSON.stringify(siteIds),
        state_ids: JSON.stringify(stateIds),
      },
    };

    return axios(config)
      .then(function (response) {
        dispatch(GenerateClientSitesReportSuccess(response.data));
        return response.data;
      })
      .catch(function (error) {
        dispatch(
          GenerateClientSitesReportFail(
            "Something went wrong, Please try again."
          )
        );
        return error;
      });
  };
};

/*** GenerateClientOverviewReport Action ***/
export const GenerateClientOverviewReportStart = () => {
  return {
    error: null,
    loader: true,
    isAuthenticated: true,
    type: actionType.GenerateClientOverviewReport_START,
  };
};
export const GenerateClientOverviewReportSuccess = (response) => {
  return {
    error: false,
    loader: false,
    isAuthenticated: response.status === 401 ? false : true,
    type: actionType.GenerateClientOverviewReport_SUCCESS,
  };
};
export const GenerateClientOverviewReportFail = (error) => {
  return {
    error: error,
    loader: false,
    isAuthenticated: error.status === 401 ? false : true,
    type: actionType.GenerateClientOverviewReport_FAIL,
  };
};

export const GenerateClientOverviewReportSection = ({
  functionId,
  searchTerm,
  filterpage,
  filterlimit,
  filtersort,
  filterorder,
  client_org_ids,
  created_date_range,
  filterStatus,
  renewalDate,
}) => {
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  return (dispatch) => {
    dispatch(GenerateClientOverviewReportStart());

    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/client/SpecificClientOverviewReport`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
      },
      params: {
        function_id: functionId,
        search: searchTerm,
        limit: filterlimit,
        page: filterpage,
        sort: filtersort,
        order: filterorder,
        status: filterStatus,
        client_org_ids: JSON.stringify(client_org_ids),
        created_date_range: created_date_range,
        renewal_date_range: renewalDate,
      },
    };

    return axios(config)
      .then(function (response) {
        dispatch(GenerateClientOverviewReportSuccess(response.data));
        return response.data;
      })
      .catch(function (error) {
        dispatch(
          GenerateClientOverviewReportFail(
            "Something went wrong, Please try again."
          )
        );
        return error;
      });
  };
};

export const TriggerClientInductionReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/TriggerClientInductionReport`,
      data: {
        ...apiData,
        client_org_ids: JSON.stringify(apiData.client_org_ids),
        provider_org_ids: JSON.stringify(
          apiData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
        com_ind_ids: JSON.stringify(
          apiData.com_ind_ids?.map((item) => item?.induction_id)
        ),
        site_ind_ids: JSON.stringify(
          apiData.site_ind_ids?.map((item) => item?.induction_id)
        ),
        worker_ids: JSON.stringify(
          apiData.worker_ids?.map((item) =>
            typeof item === "object" ? item?.worker_id ?? item?.id : item
          )
        ),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const TriggerClientInvoiceReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/TriggerClientInvoiceReport`,
      data: {
        ...apiData,
        client_org_ids: JSON.stringify([storedData?.organisation_id]),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const TriggerClientProviderDocsReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/TriggerClientProviderDocsReport`,
      data: {
        ...apiData,
        client_org_ids: JSON.stringify([storedData?.organisation_id]),
        provider_org_ids: JSON.stringify(
          apiData.provider_org_ids?.map((item) => item?.provider_org_id)
        ),
        provider_type_ids: JSON.stringify(apiData.provider_type_ids),
        document_ids: JSON.stringify(apiData.document_ids),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const TriggerClientCompChecklistReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/TriggerClientCompChecklistReport`,
      data: {
        ...apiData,
        client_org_ids: JSON.stringify(apiData.client_org_ids),
        checklist_ids: JSON.stringify(apiData.checklist_ids),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const TriggerClientSitesReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/TriggerClientSitesReport`,
      data: {
        limit: apiData.filterlimit,
        page: apiData.filterpage,
        sort: apiData.filtersort,
        order: apiData.filterorder,
        is_active: apiData.filterStatus,
        searchTerm: apiData.searchTerm,
        client_org_ids: JSON.stringify(apiData.client_org_ids ?? []),
        created_date_range: apiData.date_range,
        site_ids: JSON.stringify(apiData.siteIds ?? []),
        state_ids: JSON.stringify(apiData.stateIds ?? []),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const TriggerClientOverviewReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/TriggerClientOverviewReport`,
      data: {
        function_id: apiData.functionId,
        search: apiData.searchTerm,
        limit: apiData.filterlimit,
        page: apiData.filterpage,
        sort: apiData.filtersort,
        order: apiData.filterorder,
        status: apiData.filterStatus,
        client_org_ids: JSON.stringify(apiData.client_org_ids),
        created_date_range: apiData.created_date_range,
        renewal_date_range: apiData.renewalDate,
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
